import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "absolute",
    zIndex: 111,
    backgroundColor: "#000000",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
  },
  bgImage: {
    width: "100%",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    padding: theme.spacing.space16,
    boxSizing: "border-box",
  },
  rewardCard: {
    margin: `${theme.spacing.space40}px 0px`,
  },
  main: {
    height: "100%",
  },
  buttonGroup: {
    padding: theme.spacing.space16,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
    position: "absolute",
    bottom: theme.spacing.space48,
    width: "100%",
    boxSizing: "border-box",
    left: 0,
  },
}));
